import { designVariables } from "@studio3t/design-variables";
import { Separator } from "react-resizable-panels";
import styled, { css } from "styled-components";

// react-resizable-panels separators shared by the Studio workbench and the
// Agent page. Each is a gutter straddling a 1px hairline (`$line`); the
// grip ::after lights up on hover, drag and keyboard focus. Double-clicking
// a separator is the package's own reset to the adjacent panel's
// defaultSize.

// Divider design mirrors Mario's Sidebar sash (mario Sidebar.tsx): the visible
// part is a hairline centered inside a wider invisible hit area; hovering or
// dragging swells it to a 2px primary100 line. Hairline colors per the Studio
// frame (14090-128989): borderlight between the structure and editor panels,
// cards1Border above the output bar (it reads as card chrome there).
// The gutter overlays the neighbouring panels (negative margins + z-index),
// so it takes only the hairline's 1px of layout and the panels' content —
// row hover/selected backgrounds included — runs flush up to the divider.
export const separatorLine = css<{ $line?: string }>`
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: linear-gradient(
    ${(p) => p.$line},
    ${(p) => p.$line}
  );

  &::after {
    content: "";
    position: absolute;
    background-color: transparent;
    transition: background-color 0.15s ease;
  }

  &:hover::after,
  &[data-separator="active"]::after {
    background-color: ${(p) => p.theme.primary100};
  }

  /* Keyboard focus (TTTL-186): the grip line in the focus colour — the
     hairline is too thin for the app's inset ring, and its grab area
     straddles the gutter, so a ring around it would be cut off. */
  --focus-ring: none;
  &:focus-visible::after {
    background-color: ${designVariables.theme.light.semantic.focusprimary};
  }
`;

// Gutter between the structure and editor panels (vertical hairline).
export const ColumnSeparator = styled(Separator).attrs<{ $line?: string }>(
  (p) => ({
    $line: p.theme.semanticBorderLight,
  }),
)`
  ${separatorLine};
  width: 7px;
  margin: 0 -3px;
  cursor: col-resize;
  background-size: 1px 100%;

  &::after {
    left: 50%;
    top: 0;
    width: 2px;
    height: 100%;
    transform: translateX(-50%);
  }
`;
